var map = {
	"./18127.png": "378d",
	"./6.jpg": "06d4",
	"./7542.png": "8ba4",
	"./X.png": "aac3",
	"./bk.jpg": "a21b",
	"./dl.png": "ebed",
	"./footer-bg.png": "4ef4",
	"./icon-menu.png": "0e8e",
	"./line.png": "aa06",
	"./logo.png": "cf05",
	"./mail.gif": "9cb7",
	"./menu.svg": "36be",
	"./menupc.svg": "9746",
	"./p1.jpg": "9e75",
	"./p2.jpg": "0c3b",
	"./p3.jpg": "d982",
	"./p4.jpg": "8c30",
	"./pc1.jpg": "a591",
	"./pc2.jpg": "88ac",
	"./pc3.jpg": "5613",
	"./phone.png": "3547",
	"./shang.jpg": "bf8a",
	"./tenpo.gif": "fadb",
	"./wechat.png": "ead3",
	"./yamato.jpg": "23eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";